export const getParsedMenuItems = (menuItems?: string | any[]) => {
  return typeof menuItems === 'string'
    ? JSON.parse(menuItems || '[]')
    : menuItems
}
